export default __webpack_public_path__ + "media/cf37a582f6605c2fa1b6c765af608b3b671da672f3c8c6ba6881303af22f6f7a.svg";